import { firstOf, secondOf } from 'utils/arrays/elements.util';

const LT = -1;
const EQ = 0;
const GT = +1;

const compareEntries = (a, b) => {
  const keyA = firstOf(a);
  const keyB = firstOf(b);

  if (keyA !== keyB) return keyA < keyB ? LT : GT;

  const valA = secondOf(a);
  const valB = secondOf(b);

  return valA === valB ? EQ : valA < valB ? LT : GT;
};

export default compareEntries;
